import { render, staticRenderFns } from "./ChangePhotoPopup.vue?vue&type=template&id=10d9284e&scoped=true&"
import script from "./ChangePhotoPopup.vue?vue&type=script&lang=ts&"
export * from "./ChangePhotoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePhotoPopup.vue?vue&type=style&index=0&id=10d9284e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9284e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d9284e')) {
      api.createRecord('10d9284e', component.options)
    } else {
      api.reload('10d9284e', component.options)
    }
    module.hot.accept("./ChangePhotoPopup.vue?vue&type=template&id=10d9284e&scoped=true&", function () {
      api.rerender('10d9284e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChangePhotoPopup.vue"
export default component.exports